import { C as s } from "./component-B88NZlIm.js";
import { D as i, d as t } from "./events-CnaEWcY_.js";
import { d as l } from "./utilities-D-QcnR4L.js";
class e extends s {
  requiredRefs = ["dialog"];
  static openCount = 0;
  connectedCallback() {
    (super.connectedCallback(), this.refs.dialog.addEventListener("click", this.#o));
  }
  disconnectedCallback() {
    (super.disconnectedCallback(),
      this.refs.dialog.removeEventListener("click", this.#o),
      this.refs.dialog.open && this.#e(!1));
  }
  #o = (o) => {
    o.target === this.refs.dialog && this.closeDialog();
  };
  #e(o) {
    o
      ? (e.openCount === 0 && (document.body.style.overflow = "hidden"), e.openCount++)
      : (e.openCount--,
        e.openCount <= 0 && ((e.openCount = 0), (document.body.style.overflow = "")));
  }
  showDialog() {
    (this.refs.dialog.classList.remove("dialog-closing"),
      this.refs.dialog.showModal(),
      this.#e(!0),
      this.dispatchEvent(new i()));
  }
  closeDialog() {
    return this.refs.dialog.open
      ? (this.refs.dialog.classList.add("dialog-closing"),
        new Promise((o) => {
          this.refs.dialog.addEventListener(
            "animationend",
            () => {
              (this.refs.dialog.close(),
                this.refs.dialog.classList.remove("dialog-closing"),
                this.#e(!1),
                this.dispatchEvent(new t()),
                o());
            },
            { once: !0 }
          );
        }))
      : Promise.resolve();
  }
  toggleDialog() {
    return this.refs.dialog.open ? this.closeDialog() : (this.showDialog(), Promise.resolve());
  }
}
l("dialog-component", e);
const d = Object.freeze(
  Object.defineProperty({ __proto__: null, DialogComponent: e }, Symbol.toStringTag, {
    value: "Module",
  })
);
export { e as D, d };
